import cardpay from 'svg/cardpay.svg';
import {
  CardPaymentHeadingText,
  CardPaymentWrapper,
  CardImageContainer,
  CardPaymentWarningText,
  CardPaymentText,
} from './CardPayment.styled.ts';

interface CardPaymentProps {
  isCompleted: boolean;
}

export function CardPayment({ isCompleted }: CardPaymentProps) {
  return (
    <CardPaymentWrapper>
      {!isCompleted ? (
        <>
          <CardPaymentHeadingText>
            단말기에 카드를 삽입해주세요.
            <br />
            결제가 완료될 때까지, 카드를 뽑지 마세요.
          </CardPaymentHeadingText>
          <CardPaymentWarningText>
            Please do not remove the card after the card has been inserted.
          </CardPaymentWarningText>
          <CardPaymentText>Apple Pay, Samsung Pay 사용이 가능해요!</CardPaymentText>
        </>
      ) : (
        <>
          <CardPaymentHeadingText>
            결제가 완료되었어요!
            <br />
            결제한 카드를 회수해주세요.
          </CardPaymentHeadingText>
          <CardPaymentWarningText>
            Payment Completed! Please reclaim the card.
          </CardPaymentWarningText>
          <CardPaymentText>10초 뒤에 촬영 준비 화면으로 이동해요.</CardPaymentText>
        </>
      )}

      <CardImageContainer>
        <img src={cardpay} alt="카드 삽입" />
      </CardImageContainer>
    </CardPaymentWrapper>
  );
}
